/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../global/emotion";
import {
  colors,
  fontSizes,
  numericPixels,
  radius,
  spacing,
} from "../../../../global/emotion";
import type { CountrySelectProps } from "../forms/PhoneInput/PhoneCountrySelect.emotion";
import { PhoneCountrySelect } from "../forms/PhoneInput/PhoneCountrySelect.emotion";
import type { PhoneInputProps } from "../forms/PhoneInput/PhoneInput.emotion";
import { PhoneInput } from "../forms/PhoneInput/PhoneInput.emotion";

const baseStyle: Interpolation = {
  gap: spacing.s,
};
const inputStyle: Interpolation<ThemeType> = (theme) => ({
  background: colors.transparent,
  borderWidth: numericPixels[0],
  color: theme.semanticColors.primary,
  fontSize: fontSizes.bodyXL,
  outline: "none",
  width: spacing.full,
});
const buttonStyle: Interpolation = {
  borderRadius: radius.l,
  padding: `${spacing.s} ${spacing.none}`,
};

const InputComponent = forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>((props, ref) => {
  return <input css={inputStyle} {...props} ref={ref} />;
});
InputComponent.displayName = "InputComponent";

const CountrySelect = (props: CountrySelectProps) => {
  return (
    <PhoneCountrySelect {...props} cssOverride={{ button: [buttonStyle] }} />
  );
};
CountrySelect.displayName = "CountrySelect";

export const AuthPhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  (props, _) => {
    return (
      <PhoneInput
        css={baseStyle}
        {...props}
        inputComponent={InputComponent}
        countrySelectComponent={CountrySelect}
      />
    );
  },
);
